import Grid from "@mui/material/Grid";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

import { deviceTypeEnum } from "config/enum";

import { useEffect, useState } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function SupplierInfo({
  supplierName,
  setSupplierName,
  ascenseurDeCharge,
  setAscenseurDeCharge,
  ascenseur,
  setAscenseur,
  epmr,
  setEpmr,
  chaise,
  setChaise,
  monteChargeAccessible,
  setMonteChargeAccessible,
  monteChargeInaccessible,
  setMonteChargeInaccessible,
  porteGarage,
  setPorteGarage,
  portePietonne,
  setPortePietonne,
  portail,
  setPortail,
  porteSouple,
  setPorteSouple,
  monteFut,
  setMonteFut,
  monteVoiture,
  setMonteVoiture,
  plateformeDeCharge,
  setPlateformeDeCharge,
  plateformeEscalier,
  setPlateformeEscalier,
  plaqueTournante,
  setPlaqueTournante,
  monteMalade,
  setMonteMalade,
  montePalette,
  setMontePalette,
  portillon,
  setPortillon,
  rideau,
  setRideau,
  autreFermeture,
  setAutreFermeture,
  barriereLevante,
  setBarriereLevante,
  portailBattant,
  setPortailBattant,
  barriere,
  setBarriere,
  porte,
  setPorte,
  porteDeQuai,
  setPorteDeQuai,
  porteSectionnelle,
  setPorteSectionnelle,
  rideauMetallique,
  setRideauMetallique,
  borneEscamotable,
  setBorneEscamotable,
  interphone,
  setInterphone,
  porteVitree,
  setPorteVitree,
  portailCoulissant,
  setPortailCoulissant,
  quaiNiveleur,
  setQuaiNiveleur,
}) {
  const [selectedDeviceTypes, setSelectedDeviceTypes] = useState([]);

  useEffect(() => {
    const newSelectedDeviceTypes = [];
    if (ascenseurDeCharge) newSelectedDeviceTypes.push("Ascenseur de charge");
    if (ascenseur) newSelectedDeviceTypes.push("Ascenseur");
    if (epmr) newSelectedDeviceTypes.push("EPMR");
    if (chaise) newSelectedDeviceTypes.push("Chaise");
    if (monteChargeAccessible) newSelectedDeviceTypes.push("Monte-charge accessible");
    if (monteChargeInaccessible) newSelectedDeviceTypes.push("Monte-charge inaccessible");
    if (porteGarage) newSelectedDeviceTypes.push("Porte garage");
    if (portePietonne) newSelectedDeviceTypes.push("Porte piétonne");
    if (portail) newSelectedDeviceTypes.push("Portail");
    if (porteSouple) newSelectedDeviceTypes.push("Porte souple");
    if (monteFut) newSelectedDeviceTypes.push("Monte-fût");
    if (monteVoiture) newSelectedDeviceTypes.push("Monte-voiture");
    if (plateformeDeCharge) newSelectedDeviceTypes.push("Plateforme de charge");
    if (plateformeEscalier) newSelectedDeviceTypes.push("Plateforme escalier");
    if (plaqueTournante) newSelectedDeviceTypes.push("Plaque tournante");
    if (monteMalade) newSelectedDeviceTypes.push("Monte-malade");
    if (montePalette) newSelectedDeviceTypes.push("Monte-palette");
    if (portillon) newSelectedDeviceTypes.push("Portillon");
    if (rideau) newSelectedDeviceTypes.push("Rideau");
    if (autreFermeture) newSelectedDeviceTypes.push("Autre fermeture");
    if (barriereLevante) newSelectedDeviceTypes.push("Barrière levante");
    if (portailBattant) newSelectedDeviceTypes.push("Portail battant");
    if (barriere) newSelectedDeviceTypes.push("Barrière");
    if (porte) newSelectedDeviceTypes.push("Porte");
    if (porteDeQuai) newSelectedDeviceTypes.push("Porte de quai");
    if (porteSectionnelle) newSelectedDeviceTypes.push("Porte sectionnelle");
    if (rideauMetallique) newSelectedDeviceTypes.push("Rideau métallique");
    if (borneEscamotable) newSelectedDeviceTypes.push("Borne escamotable");
    if (interphone) newSelectedDeviceTypes.push("Interphone");
    if (porteVitree) newSelectedDeviceTypes.push("Porte vitrée");
    if (portailCoulissant) newSelectedDeviceTypes.push("Portail coulissant");
    if (quaiNiveleur) newSelectedDeviceTypes.push("Quai niveleur");
    setSelectedDeviceTypes(newSelectedDeviceTypes);
  }, [
    ascenseurDeCharge,
    ascenseur,
    epmr,
    chaise,
    monteChargeAccessible,
    monteChargeInaccessible,
    porteGarage,
    portePietonne,
    portail,
    porteSouple,
    monteFut,
    monteVoiture,
    plateformeDeCharge,
    plateformeEscalier,
    plaqueTournante,
    monteMalade,
    montePalette,
    portillon,
    rideau,
    autreFermeture,
    barriereLevante,
    portailBattant,
    barriere,
    porte,
    porteDeQuai,
    porteSectionnelle,
    rideauMetallique,
    borneEscamotable,
    interphone,
    porteVitree,
    portailCoulissant,
    quaiNiveleur,
  ]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={supplierName}
            onChange={(event) => setSupplierName(event.target.value)}
            variant="standard"
            required
            type="text"
            label="Nom"
          />
        </Grid>
        <Grid item xs={8}>
          <Autocomplete
            multiple
            onChange={(event, newValue) => {
              if (newValue.includes("Ascenseur de charge")) setAscenseurDeCharge(1);
              else setAscenseurDeCharge(0);
              if (newValue.includes("Ascenseur")) setAscenseur(1);
              else setAscenseur(0);
              if (newValue.includes("EPMR")) setEpmr(1);
              else setEpmr(0);
              if (newValue.includes("Chaise")) setChaise(1);
              else setChaise(0);
              if (newValue.includes("Monte-charge accessible")) setMonteChargeAccessible(1);
              else setMonteChargeAccessible(0);
              if (newValue.includes("Monte-charge inaccessible")) setMonteChargeInaccessible(1);
              else setMonteChargeInaccessible(0);
              if (newValue.includes("Porte garage")) setPorteGarage(1);
              else setPorteGarage(0);
              if (newValue.includes("Porte piétonne")) setPortePietonne(1);
              else setPortePietonne(0);
              if (newValue.includes("Portail")) setPortail(1);
              else setPortail(0);
              if (newValue.includes("Porte souple")) setPorteSouple(1);
              else setPorteSouple(0);
              if (newValue.includes("Monte-fût")) setMonteFut(1);
              else setMonteFut(0);
              if (newValue.includes("Monte-voiture")) setMonteVoiture(1);
              else setMonteVoiture(0);
              if (newValue.includes("Plateforme de charge")) setPlateformeDeCharge(1);
              else setPlateformeDeCharge(0);
              if (newValue.includes("Plateforme escalier")) setPlateformeEscalier(1);
              else setPlateformeEscalier(0);
              if (newValue.includes("Plaque tournante")) setPlaqueTournante(1);
              else setPlaqueTournante(0);
              if (newValue.includes("Monte-malade")) setMonteMalade(1);
              else setMonteMalade(0);
              if (newValue.includes("Monte-palette")) setMontePalette(1);
              else setMontePalette(0);
              if (newValue.includes("Portillon")) setPortillon(1);
              else setPortillon(0);
              if (newValue.includes("Rideau")) setRideau(1);
              else setRideau(0);
              if (newValue.includes("Autre fermeture")) setAutreFermeture(1);
              else setAutreFermeture(0);
              if (newValue.includes("Barrière levante")) setBarriereLevante(1);
              else setBarriereLevante(0);
              if (newValue.includes("Portail battant")) setPortailBattant(1);
              else setPortailBattant(0);
              if (newValue.includes("Barrière")) setBarriere(1);
              else setBarriere(0);
              if (newValue.includes("Porte")) setPorte(1);
              else setPorte(0);
              if (newValue.includes("Porte de quai")) setPorteDeQuai(1);
              else setPorteDeQuai(0);
              if (newValue.includes("Porte sectionnelle")) setPorteSectionnelle(1);
              else setPorteSectionnelle(0);
              if (newValue.includes("Rideau métallique")) setRideauMetallique(1);
              else setRideauMetallique(0);
              if (newValue.includes("Borne escamotable")) setBorneEscamotable(1);
              else setBorneEscamotable(0);
              if (newValue.includes("Interphone")) setInterphone(1);
              else setInterphone(0);
              if (newValue.includes("Porte vitrée")) setPorteVitree(1);
              else setPorteVitree(0);
              if (newValue.includes("Portail coulissant")) setPortailCoulissant(1);
              else setPortailCoulissant(0);
              if (newValue.includes("Quai niveleur")) setQuaiNiveleur(1);
              else setQuaiNiveleur(0);
            }}
            id="checkboxes-tags-demo"
            options={deviceTypeEnum}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} variant="standard" label="Types d'appareil" />
            )}
            value={selectedDeviceTypes}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
